/* eslint-disable react/display-name */
import React, { useState } from 'react';
import { Select } from 'antd';
import Item from 'antd/lib/list/Item';

const { Option } = Select;

interface RegionEditProps extends React.HTMLAttributes<HTMLElement> {
  onChange?: any;
  defaultValue?: any;
  style?: any;
  dataSource: any;
  placeholder?: string;
  valueKey: string;
  allOptionName?: string;
  allOptionValue?: string;
  value?: string;
}

const InputTag: React.FC<RegionEditProps> = ({
  onChange,
  defaultValue,
  style,
  dataSource,
  placeholder,
  valueKey,
  allOptionName,
  allOptionValue="",
  value
}) => {
  return (
    <Select
      open={false}
      mode={"tags"}
      onChange={onChange}
      defaultValue={defaultValue}
      placeholder={placeholder}
      style={{ border: '1px solid #d9d9d9', ...style}}
      {...value ? {value} : {}}
    >
      {allOptionName && (
        <Option selected={defaultValue === allOptionValue} key="all" value={allOptionValue}>
          {allOptionName}
        </Option>
      )}
      {dataSource &&
        dataSource.map((item: any) => (
          item && <Option key={item.id || item} value={valueKey ? item[valueKey] : item}>
            {valueKey ? item[valueKey] : item}
          </Option>
        ))}
    </Select>
  );
};
export default InputTag;
